import { LDFlagKeys } from '.';

export const defaultLDFlagValues: Partial<Record<LDFlagKeys, boolean>> = {
  [LDFlagKeys.demoMode]: false,
};
